(function (angular) {

    "use strict";

    angular
        .module('harriApp')
        .controller('LandingPageController', [
            "$element", "$scope", "$modal", "$stateParams", "$window", "hUser", "$state", "$rootScope", "hEvent", "localize", "hotJarTracking", "appLayoutViewService",
            function ($element, $scope, $modal, $stateParams, $window, hUser, $state, $rootScope, hEvent, localize, hotJarTracking, appLayoutViewService) {
            $scope.hasSignupCode = $stateParams.code;

            hotJarTracking.addTracking();

            var self = this;
            self.loading = true;
            self.wpDynamicTemplate = $state.current.wpDynamicTemplate;

            self.elementorModulesLoaded = false;
            var checkElementorModulesInterval;
                checkElementorModulesInterval = setInterval(function () {
                if (!!window.elementorModules) {
                    self.elementorModulesLoaded = true;
                    clearInterval(checkElementorModulesInterval);
                    $scope.$digest();
                }
            }, 10);


            if ($state.current.name === "homepage-uk") {
                self.loading = false;
                $scope.pageVersion = 'UK';
            }
            else {
                hUser.isFromUK()
                    .then(function (isUK) {
                        self.loading = false;
                        self.isFromUK = isUK;
                        if (isUK) {
                            $scope.pageVersion = 'UK';
                        } else {
                            $scope.pageVersion = 'US';
                        }

                    });
            }



            $scope.userInteracted = '';
            $scope.isMobile = $(window).width() < 768;

            $(document).on("scroll.homepage", function () {
                $scope.userInteracted = true;
                $(document).off("scroll.homepage");
                $scope.$digest();
            });

            $scope.accordionIndex = 0;

            $scope.isRussian = localize.getLang() === 'ru';

            $scope.getLogoLink = function () {
                return !hUser.isTopLevelContext() ? '/' : $state.href('appLayout.harriSH.access-portal.main');
            };

            $rootScope.$on('user_updated', function (event) {
                $scope.isLoggedIn = hUser.isLoggedIn();
                $scope.isEmployer = hUser.isEmployer();
            });

            hUser.init()
                .then(function () {
                    appLayoutViewService.updateBrandTheme();
                });

            $('.the-standard-slider').slick({
                autoplay: true,
                arrows: false,
                fade: true
            });

            $(".watch-video").fancybox({
                maxWidth: 800,
                maxHeight: 600,
                fitToView: false,
                width: '100%',
                height: '70%',
                autoSize: false,
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none'
            });



            var showEmployerQuickRegisterModal = function () {
                $modal({
                    controller: 'EmployerQuickRegisterModalController',
                    templateUrl: '../modules/emp_quick_reg/views/employer_quick_register_modal.html',
                    show: true,
                    resolve: {}
                });
            };

            $scope.postJob = function () {
                /* if logged in take to page directly */
                if (hUser.isLoggedIn()) {
                    $state.go('appLayout.harriSH.job_create');
                    /* otherwise save the redirect link and show login form */
                } else {
                    var LinkTo = $state.href('appLayout.harriSH.job_create');
                    hUser.setLinkAfterLoginSuccessfully(LinkTo);
                    showEmployerQuickRegisterModal();
                }

            };

            $scope.scheduleDemo = function (source) {
                var data = "";
                var analyticsData = $.extend({
                    label: source,
                    category:"salesRequest"
                }, data);

                hEvent.track('demo_request', analyticsData);

                var modalData = function () {
                    return {
                        source: source,
                        pageVersion: $scope.pageVersion,
                        isMobile: $scope.isMobile,
                        type: 'demo_request'
                    };
                };

                ngLandingPagesUtils.handleRequestDemoClick(modalData);
            };

            $scope.scrollToLMSPackages = function () {
                $('html, body').animate({scrollTop: $("#lms-landing-pricing").offset().top - 100}, 1000);
            };

            $scope.requestPricing = function (source) {
                var data = "";
                var analyticsData = $.extend({
                    label: source,
                    category:"salesRequest"
                }, data);

                hEvent.track('contact_sales', analyticsData);
                var modalData =  function () {
                    return {
                        source: source,
                        pageVersion: $scope.pageVersion,
                        isMobile: $scope.isMobile,
                        type: 'contact_sales'
                    };
                };
                $modal(getRequestDemo2020Modal(modalData));
            };

            $scope.openLandingPagesModal = function(options) {

                var data = "";
                var analyticsData = $.extend({
                    label: options.iframeUrl,
                    category:"salesRequest"
                }, data);

                hEvent.track('open_landing_pages_modal', analyticsData);

                var modalData =  function () {
                    return $.extend( options, {
                        pageVersion: $scope.pageVersion,
                    });
                };
                $modal(getLandingPagesModal(modalData));
            };

            self.isSideBarExpanded = function () {
                return appLayoutViewService.isSideBarExpanded();
            };

            self.getToggleSource = function () {
                return appLayoutViewService.getToggleSource();
            };

            window.wpActions = {
                scheduleDemo: $scope.scheduleDemo,
                requestPricing: $scope.requestPricing,
                openLandingPagesModal: $scope.openLandingPagesModal,
                watchVideo: function () {
                }
            };

            $("#harriApp").off("click", "[contact-sales]");
            $("#harriApp").on("click", "[contact-sales]", function () {
                var source = $(this).attr("contact-sales");
                window.wpActions.requestPricing(source);
            });

            $("#harriApp").off("click", "[request-demo]");
            $("#harriApp").on("click", "[request-demo]", function () {
                var source = $(this).attr("request-demo");
                window.wpActions.scheduleDemo(source);
            });

                $("#harriApp").off("click", "[landing-page-modal]");
                $("#harriApp").on("click", "[landing-page-modal]", function () {
                    var options = {
                        title: $(this).attr("modal-title"),
                        description: $(this).attr("modal-description"),
                        iframeUrl: $(this).attr("modal-iframe-url"),
                        iframeWidth: $(this).attr("modal-iframe-width"),
                        iframeHeight: $(this).attr("modal-iframe-height"),
                    };
                    window.wpActions.openLandingPagesModal(options);
                });

                let videoUpdated = false;

                const domMutationObserver = new YDomMutationObserver();

                const landingPageVideoHandler = function () {
                    if (videoUpdated) {
                        domMutationObserver?.destroy();
                        return;
                    }

                    setTimeout(() => {
                        if ($('[watch-video]').length) {
                            const elm = $('[watch-video]');
                            const videoUrl = elm.attr('watch-video').split("/");
                            const videoId = videoUrl[videoUrl.length - 1];
                            elm.attr('href', 'https://player.vimeo.com/video/' + videoId + '?color=ffc4da&byline=0&portrait=0&badge=0&autoplay=true');
                            elm.addClass('watch-video fancybox.iframe');
                        }

                        if (window.location.href.indexOf('watch-video') > -1) {
                            $('[watch-video]').first().trigger('click');
                        }
                        videoUpdated = true;
                    }, 100);
                };

                domMutationObserver.init($element.get(0));
                domMutationObserver.on(YDomMutationObserver.EVENTS.ON_CHILD_LIST_CHANGED, landingPageVideoHandler);
                domMutationObserver.on(YDomMutationObserver.EVENTS.ON_SUBTREE_CHANGED, landingPageVideoHandler);
                domMutationObserver.on(YDomMutationObserver.EVENTS.ON_CHANGE, landingPageVideoHandler);
                domMutationObserver.startListening();

            $scope.LMSContactUs = function () {
                $modal({
                    controller: 'LMSContactUsModalController',
                    controllerAs: "$ctrl",
                    templateUrl: '../hmodules/lms/modals/lms-contact-us-modal/lms-contact-us.modal.html',
                    show: true,
                    resolve: {
                        modalData: function(){
                            return {
                                isContactUsFlow: true,
                                brand_id: hUser.getEntryMode()? hUser.getEntryMode().brand_id: null,
                                type: LMSFollowUpAPI.TYPES.CONTACT_US
                            };
                        },
                        onSave: function(){
                            return function () {};
                        },
                        onClose: function() {
                            return function () {};
                        }
                    }
                });
            };

            if ($('.sticky-schedule-demo-section').length) {
                angular.element($window).on('scroll.sticky-schedule-demo-section', function () {
                    if ($window.scrollY > ($('.landing-page-container').offset().top + $('.landing-page-container').height() - $(window).height())) {
                        $('.schedule-demo-section').css({'bottom': 0, 'position': 'absolute'});
                    } else {
                        $('.schedule-demo-section').css({'bottom': 0, 'position': 'fixed'});
                    }
                });
            }

            $(document).on("scroll.header2018", function () {
                if ($(this).scrollTop() > 70) {
                    $(".header2018").addClass("fixed");
                } else {
                    $(".header2018").removeClass("fixed");
                }
            });

            $scope.$on('$destroy', function (e) {
                $(document).off("scroll.header2018");
                $(document).off("scroll.homepage");
                angular.element($window).off(".sticky-schedule-demo-section");
                domMutationObserver?.destroy();
            });

            $scope.scrollToTheTarget = function (target) {

                $('html, body').animate({
                    scrollTop: $('#' + target).offset().top - 81
                }, 1000);
            };

            var parallaxBlocks = $.find('.parallax');
            var animatedElms = $.find('.animate-when-pone-is-visible');
            var harriNumbers = $('.harri-numbers');

            var harriNumbersDetails = $('.harri-numbers-details li');
            var numbersAnimated = false;

            /**
             * Private functions
             */
            function hasClass(elm, animationType) {
                var $elm = $(elm);

                return $elm.hasClass(animationType);
            }

            function checkIfElementInView(elm) {
                if (elm.length === 0) {
                    return;
                }

                var $window = $(window);
                var viewport_top = $window.scrollTop();
                var viewport_height = $window.height();
                var viewport_bottom = viewport_top + viewport_height;
                var $elm = $(elm);
                var top = $elm.offset().top;
                var height = $elm.height();
                var bottom = top + height;

                return (top >= viewport_top && top < viewport_bottom) ||
                    (bottom > viewport_top && bottom <= viewport_bottom) ||
                    (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
            }

            function parallax(elm) {
                if (checkIfElementInView(elm)) {
                    var $elm = $(elm);
                    var $window = $(window);
                    var parallaxElm = $elm.find('.bg-wrapper-inner');
                    var distance = ((($window.scrollTop() + $window.height()) - ($elm.offset().top)) * -1) / 6;

                    parallaxElm.css({
                        '-webkit-transform' : 'translateY(' + distance + 'px)',
                        '-moz-transform'    : 'translateY(' + distance + 'px)',
                        '-ms-transform'     : 'translateY(' + distance + 'px)',
                        '-o-transform'      : 'translateY(' + distance + 'px)',
                        'transform'         : 'translateY(' + distance + 'px)'
                    });
                }
            }

            function doAnimation(elm) {
                var $elm = $(elm);
                var animationDelay = $elm.data('animation-delay');
                var animationType = $elm.data('animation-type');
                var timingFunction = $elm.data('animation-function');
                var animationDuration = $elm.data('animation-duration');

                if (animationDelay) {
                    if (!hasClass(elm, animationDelay)) {
                        $elm.addClass(animationDelay);
                    }
                }

                if (timingFunction) {
                    if (!hasClass(elm, timingFunction)) {
                        $elm.addClass(timingFunction);
                    }
                }

                if (animationDuration) {
                    if (!hasClass(elm, animationDuration)) {
                        $elm.addClass(animationDuration);
                    }
                }

                if (animationType) {
                    if (!hasClass(elm, animationType)) {
                        $elm.addClass(animationType);
                    }
                }
            }

            function checkForAnimation() {
                animatedElms.forEach(function (elm) {
                    if (checkIfElementInView(elm) || hasClass(elm, 'not-in-view')) {
                        doAnimation(elm);
                    }
                });
            }

            function checkForWholeAnimations() {
                checkForAnimation();

                $(window).scroll(function () {
                    parallaxBlocks.forEach(function (block) {
                        if (!$(block).hasClass('no-effects')) {
                            parallax(block);
                        }
                    });

                    if (animatedElms.length) {
                        checkForAnimation();
                    }
                });
            }

            checkForWholeAnimations();

            // Pardot integration
            window.piAId = '235402';
            window.piCId = '1066';
            window.piHostname = 'pi.pardot.com';

            function async_load() {
                var s = document.createElement('script');
                s.type = 'text/javascript';
                s.src =  'https://pi.pardot.com/pd.js';
                var c = document.getElementsByTagName('script')[0];
                c.parentNode.insertBefore(s, c);
            }

            if (!window.pardotLoaded) {
                window.pardotLoaded = true;
                async_load();
            }


            $(document).ready(function() {

                var hash = window.location.hash;

                var activeTabIndicator = "#tab-";
                if (hash && hash.substring(0, activeTabIndicator.length) === activeTabIndicator) {

                    var tabKey = hash.substring(activeTabIndicator.length);
                    var selector = '[data-tab-key="'+tabKey+'"]';

                    $(selector)
                        .closest("[data-tab]")
                        .each(function() {
                            var target = $(this);
                            if (target.is(":visible")) {
                                target.trigger( "click" );
                                $('html, body').animate({
                                    scrollTop: target.offset().top - 81
                                }, 500);
                                return false;
                            }
                        });

                }

                $('.elementor-tab-title').click(function () {
                    var tabKey = $(this).find('[data-tab-key]').data('tab-key');
                    if (tabKey) {
                        var newUrl = window.location.origin +  window.location.pathname + activeTabIndicator + tabKey;
                        history.replaceState(undefined, undefined, newUrl);
                    }
                });
            });

        }]);
})(angular);
